module.exports = __webpack_public_path__ + "media/media/home/img11-48e9ada49b905c0dac18c3de973b2328.png";